(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cinematic-parallax"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const scenes = document.querySelectorAll('[data-parallax-scene]');
    if (!scenes.length) return;

    // Parallax scroll effect (desktop only)
    if (!isMobile) {
      let ticking = false;
      function updateParallax() {
        const scrollY = window.scrollY;
        scenes.forEach(scene => {
          const rect = scene.getBoundingClientRect();
          const sceneTop = rect.top + scrollY;
          const speed = parseFloat(scene.getAttribute('data-speed')) || 0.4;
          
          // Check if scene is near viewport
          if (scrollY + window.innerHeight + 200 < sceneTop || scrollY - 200 > sceneTop + rect.height) return;
          
          const media = scene.querySelector('.parallax-media, .parallax-video');
          if (media && !media.classList.contains('ken-burns') && !media.classList.contains('ken-burns-pan')) {
            // Apply parallax shift only if not Ken Burns (or video)
            const relativeScroll = scrollY - sceneTop;
            const yOffset = relativeScroll * speed;
            media.style.transform = `translateY(${yOffset * 0.3}px)`;
          }
        });
        ticking = false;
      }
      
      window.addEventListener('scroll', () => {
        if (!ticking) {
          requestAnimationFrame(updateParallax);
          ticking = true;
        }
      });
      updateParallax();
    }

    // Ensure videos play (autoplay policy)
    const videos = document.querySelectorAll('.parallax-video');
    videos.forEach(video => {
      video.play().catch(e => console.log('Video autoplay blocked:', e));
    });

    // Text fade-in on scroll (all devices)
    const textElements = document.querySelectorAll('[data-parallax-content]');
    const textObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        } else {
          entry.target.classList.remove('visible');
        }
      });
    }, { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });
    
    textElements.forEach(el => textObserver.observe(el));
    
    // Initial visible check
    setTimeout(() => {
      textElements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight - 100 && rect.bottom > 100) {
          el.classList.add('visible');
        }
      });
    }, 200);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-carousel"] && !Shopify.designMode) return;
  try {
    
class EBMediaCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-eb-mc-slide]')?.parentElement;
    this.slides = Array.from(this.querySelectorAll('[data-eb-mc-slide]'));
    const root = this.closest('.eb-mc') || this.parentElement;
    this.prev = root?.querySelector('[data-eb-prev]');
    this.next = root?.querySelector('[data-eb-next]');
    if (!this.track) return;
    this.prev?.addEventListener('click', () => this.scrollByCard(-1));
    this.next?.addEventListener('click', () => this.scrollByCard(1));
    this.onScroll = this.debounce(() => this.updateArrows(), 80);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.updateArrows();
  }
  disconnectedCallback() { this.track?.removeEventListener('scroll', this.onScroll); }
  scrollByCard(dir) {
    const card = this.slides[0];
    if (!card) return;
    const gap = parseFloat(getComputedStyle(this.track).columnGap || '0') || 0;
    this.track.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
  }
  updateArrows() {
    if (!this.prev || !this.next) return;
    const max = this.track.scrollWidth - this.track.clientWidth - 2;
    this.prev.disabled = this.track.scrollLeft <= 2;
    this.next.disabled = this.track.scrollLeft >= max;
  }
  debounce(fn, ms) { let t; return () => { clearTimeout(t); t = setTimeout(fn, ms); }; }
}
if (!customElements.get('media-carousel')) customElements.define('media-carousel', EBMediaCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-with-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // ---------- PARALLAX (desktop only) ----------
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (!isMobile) {
      const parallaxBlocks = document.querySelectorAll('[data-parallax-block]');
      
      function updateParallax() {
        parallaxBlocks.forEach(block => {
          const bg = block.querySelector('[data-parallax-bg]');
          if (!bg) return;
          const speed = parseFloat(block.getAttribute('data-speed')) || 0.5;
          const rect = block.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          // Only transform when block is in or near viewport
          if (rect.top < windowHeight + 200 && rect.bottom > -200) {
            const scrolled = window.scrollY;
            const blockTop = block.offsetTop;
            const yPos = (scrolled - blockTop) * speed;
            bg.style.transform = `translateY(${yPos * 0.3}px)`;
          }
        });
        requestAnimationFrame(updateParallax);
      }
      
      window.addEventListener('scroll', () => {
        requestAnimationFrame(updateParallax);
      });
      updateParallax();
    }

    // ---------- TEXT FADE IN ON SCROLL (all devices) ----------
    const contentElements = document.querySelectorAll('[data-parallax-content]');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        } else {
          // Optional: remove class if you want re-triggering (default keeps visible)
          // entry.target.classList.remove('visible');
        }
      });
    }, { threshold: 0.2 });
    
    contentElements.forEach(el => observer.observe(el));
    
    // Force first visible items to appear on load
    setTimeout(() => {
      contentElements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight - 100) {
          el.classList.add('visible');
        }
      });
    }, 100);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-card-carousel"] && !Shopify.designMode) return;
  try {
    
/* Shared AJAX add-to-cart — matches Dawn-family cart-drawer / cart-notification hooks */
class EBProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.submitBtn = this.querySelector('[type="submit"]');
    this.errorEl = this.querySelector('[data-eb-pf-error]');
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }
  get cart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }
  async onSubmit(evt) {
    if (this.submitBtn && this.submitBtn.getAttribute('aria-disabled') === 'true') return;
    evt.preventDefault();
    this.toggleLoading(true);
    if (this.errorEl) this.errorEl.hidden = true;

    const formData = new FormData(this.form);
    const cart = this.cart;
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map((s) => s.section).join(','));
      formData.append('sections_url', window.location.pathname);
    }
    const addUrl =
      (window.routes && window.routes.cart_add_url) ||
      ((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js');

    try {
      const res = await fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const data = await res.json();
      if (data.status) {
        this.showError(data.description || data.message || 'Could not add to cart.');
        return;
      }
      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(data);
        if (typeof cart.open === 'function') cart.open();
      } else {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      }
    } catch (e) {
      window.location = '/cart';
    } finally {
      this.toggleLoading(false);
    }
  }
  toggleLoading(state) {
    if (!this.submitBtn) return;
    this.submitBtn.classList.toggle('eb-btn--loading', state);
    this.submitBtn.setAttribute('aria-busy', state ? 'true' : 'false');
  }
  showError(msg) {
    if (!this.errorEl) return;
    this.errorEl.textContent = msg;
    this.errorEl.hidden = false;
  }
}
if (!customElements.get('eb-product-form')) customElements.define('eb-product-form', EBProductForm);

class EBScrollCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-eb-slide]')?.parentElement;
    this.slides = Array.from(this.querySelectorAll('[data-eb-slide]'));
    this.dotsWrap = this.querySelector('[data-eb-dots]');
    if (!this.track || this.slides.length < 2) return;
    this.buildDots();
    this.onScroll = this.debounce(() => this.syncDots(), 80);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.syncDots();
  }
  disconnectedCallback() { this.track?.removeEventListener('scroll', this.onScroll); }
  buildDots() {
    if (!this.dotsWrap) return;
    this.dotsWrap.setAttribute('aria-hidden', 'false');
    this.dots = this.slides.map((slide, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'eb-pcc__dot';
      b.setAttribute('aria-label', `Go to item ${i + 1}`);
      b.addEventListener('click', () => slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' }));
      this.dotsWrap.appendChild(b);
      return b;
    });
  }
  syncDots() {
    if (!this.dots) return;
    const mid = this.track.scrollLeft + this.track.clientWidth / 2;
    let active = 0, min = Infinity;
    this.slides.forEach((s, i) => {
      const c = s.offsetLeft + s.offsetWidth / 2;
      const d = Math.abs(c - mid);
      if (d < min) { min = d; active = i; }
    });
    this.dots.forEach((d, i) => d.setAttribute('aria-current', i === active ? 'true' : 'false'));
  }
  debounce(fn, ms) { let t; return () => { clearTimeout(t); t = setTimeout(fn, ms); }; }
}
if (!customElements.get('scroll-carousel')) customElements.define('scroll-carousel', EBScrollCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-spotlight-slider"] && !Shopify.designMode) return;
  try {
    
/* Shared AJAX add-to-cart — matches Dawn-family cart-drawer / cart-notification hooks */
class EBProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.submitBtn = this.querySelector('[type="submit"]');
    this.errorEl = this.querySelector('[data-eb-pf-error]');
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }
  get cart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }
  async onSubmit(evt) {
    if (this.submitBtn && this.submitBtn.getAttribute('aria-disabled') === 'true') return;
    evt.preventDefault();
    this.toggleLoading(true);
    if (this.errorEl) this.errorEl.hidden = true;

    const formData = new FormData(this.form);
    const cart = this.cart;
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map((s) => s.section).join(','));
      formData.append('sections_url', window.location.pathname);
    }
    const addUrl =
      (window.routes && window.routes.cart_add_url) ||
      ((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js');

    try {
      const res = await fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const data = await res.json();
      if (data.status) {
        this.showError(data.description || data.message || 'Could not add to cart.');
        return;
      }
      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(data);
        if (typeof cart.open === 'function') cart.open();
      } else {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      }
    } catch (e) {
      window.location = '/cart';
    } finally {
      this.toggleLoading(false);
    }
  }
  toggleLoading(state) {
    if (!this.submitBtn) return;
    this.submitBtn.classList.toggle('eb-btn--loading', state);
    this.submitBtn.setAttribute('aria-busy', state ? 'true' : 'false');
  }
  showError(msg) {
    if (!this.errorEl) return;
    this.errorEl.textContent = msg;
    this.errorEl.hidden = false;
  }
}
if (!customElements.get('eb-product-form')) customElements.define('eb-product-form', EBProductForm);

class EBSpotlightSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-eb-spot-slide]')?.parentElement;
    this.slides = Array.from(this.querySelectorAll('[data-eb-spot-slide]'));
    this.dotsWrap = this.querySelector('[data-eb-spot-dots]');
    this.counter = this.querySelector('[data-eb-spot-counter]');
    if (!this.track || this.slides.length < 2) return;
    this.buildDots();
    this.onScroll = this.debounce(() => this.sync(), 80);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.sync();
  }
  disconnectedCallback() { this.track?.removeEventListener('scroll', this.onScroll); }
  buildDots() {
    if (!this.dotsWrap) return;
    this.dotsWrap.setAttribute('aria-hidden', 'false');
    this.dots = this.slides.map((slide, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'eb-spot__dot';
      b.setAttribute('aria-label', `Go to slide ${i + 1}`);
      b.addEventListener('click', () => slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }));
      this.dotsWrap.appendChild(b);
      return b;
    });
  }
  sync() {
    const mid = this.track.scrollLeft + this.track.clientWidth / 2;
    let active = 0, min = Infinity;
    this.slides.forEach((s, i) => {
      const c = s.offsetLeft + s.offsetWidth / 2;
      const d = Math.abs(c - mid);
      if (d < min) { min = d; active = i; }
    });
    if (this.dots) this.dots.forEach((d, i) => d.setAttribute('aria-current', i === active ? 'true' : 'false'));
    if (this.counter) this.counter.textContent = `${active + 1}/${this.slides.length}`;
  }
  debounce(fn, ms) { let t; return () => { clearTimeout(t); t = setTimeout(fn, ms); }; }
}
if (!customElements.get('spotlight-slider')) customElements.define('spotlight-slider', EBSpotlightSlider);

  } catch(e) { console.error(e); }
})();
})();
